export function useScrollSliderCardControls() {
  const scrollContainer = useTemplateRef<HTMLDivElement>("scrollContainer");
  const carouselItems = useTemplateRef<HTMLDivElement[]>("carouselItems");
  const isControlToPreviousEnabled = ref<boolean>(true);
  const isControlToNextEnabled = ref<boolean>(false);

  function handleScrollEnd() {
    if (scrollContainer.value) {
      isControlToPreviousEnabled.value = scrollContainer.value.scrollLeft <= 0;

      isControlToNextEnabled.value =
        Math.ceil(
          scrollContainer.value.clientWidth + scrollContainer.value.scrollLeft
        ) >= scrollContainer.value.scrollWidth;
    }
  }

  function toNext(scrollOffset: number) {
    scrollContainer.value?.scrollBy({ left: scrollOffset, behavior: "smooth" });
  }

  function toPrevious(scrollOffset: number) {
    scrollContainer.value?.scrollBy({ left: -scrollOffset, behavior: "smooth" });
  }

  function toStart() {
    scrollContainer.value?.scrollTo({
      left: 0,
      behavior: "smooth"
    });
  }

  return {
    scrollContainer,
    carouselItems,
    isControlToPreviousEnabled,
    isControlToNextEnabled,
    handleScrollEnd,
    toNext,
    toPrevious,
    toStart,
  };
}